import AxiosInstance from "../config/AxiosInstance";

export const getSalesLedger = async (page: any, limit: any, search: any, companyId: any, previos: any, location: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/finex/sales/getSaleLedger', {
            params: {
                page: page,
                limit: limit,
                search: search,
                companyId: companyId,
                previous: previos,
                location: location
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
};

export const getPurchasesLedger = async (page: any, limit: any, search: any, companyId: any, previos: any, location: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/finex/purchases/getPurchaseLedger', {
            params: {
                page: page,
                limit: limit,
                search: search,
                companyId: companyId,
                previous: previos,
                location: location
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
};

export const getSalesLedgerPDF = async (companyId: any, previos: any, location: any, search: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/finex/sales/creatSaleLedgerPDF/', {
            params: {
                companyId: companyId,
                previous: previos,
                location: location,
                search: search,
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
};
export const getSalesLedgerXLS = async (companyId: any, previos: any, location: any, search: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/finex/sales/createTakKosovoSalesLedgerExcel/', {
            params: {
                companyId: companyId,
                previous: previos,
                location: location,
                search: search,
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
};
export const getPurchasesLedgerPDF = async (companyId: any, previos: any, location: any, search: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/finex/purchases/creatPurchaseLedgerPDF/', {
            params: {
                companyId: companyId,
                previous: previos,
                location: location,
                search: search,
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
};
export const getPurchasesLedgerXLS = async (companyId: any, previos: any, location: any, search: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/finex/purchases/createPurchasesLedgerExcel/', {
            params: {
                companyId: companyId,
                previous: previos,
                location: location,
                search: search,
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
};
export const getTransactionMonthLedger = async (companyId: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/finex/transaction-month/getAllTransactionMonths', {
            params: {
                companyId: companyId,
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }


}